<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Redeem
      </div>
    </template>
  
    <Section>
      <div class="black--text" style="font-size: 16px;">
        Select the gift card of your choice!
      </div>

      <div class="d-flex flex-wrap mt-3 justify-space-between">
        <CatalogItem v-for="item in catalog.items" :key="item.utid" :item="item" @click="cardClick(item.brand_key)"/>
      </div>

      <div class="mt-3" style="font-size: 10px; line-height: 1.25">
        {{  catalog.catalog_disclaimer }}
      </div>
    </Section>

    <ErrorOverlay title="Problem Redeeming" v-model="error_dialog" :loading="loading" >
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>

<script>
import CatalogItem from './CatalogItem'
import { ContentPage, Section } from '@/components/pages'

import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RewardsRedeemView',

  mixins: [ ErrorOverlayMixin ],

  components: { CatalogItem, ContentPage, Section },

  computed: {
    ...mapGetters('rewards', ['catalog']),
  },

  methods: {
    ...mapActions('rewards', ['loadCatalog']),

    cardClick(brand_key) {
      this.$router.push({ name: 'redeem/card', params: { brand_key } })
    },
  },

  async created() {
    this.loading = true
    await this.loadCatalog()
    this.loading = false
  },
}
</script>
